import { resetPassword } from "@store/visitWidgetApi";
import { AppDispatch } from "@store/store";
import { logError } from "@lib/logger";
import { setAuthViewAction } from "@store/sessionReducer";

export interface ResetPasswordRequestActionParams {
  email: string;
  captcha: string;
}

/*
 * Request reset password
 */
const resetPasswordRequestAction =
  ({ email, captcha }: ResetPasswordRequestActionParams) =>
  async (dispatch: AppDispatch) => {
    try {
      await resetPassword({ email, captcha });
      dispatch(setAuthViewAction({ authView: "resetPasswordRequestSent" }));
    } catch (error) {
      logError(error);
      throw error;
    }
  };

export { resetPasswordRequestAction };
